import { getApiUrl } from './shared.js';

// Ключ, под которым в localStorage хранятся данные авторизации.
export const AUTH_STORAGE_KEY = 'ilovebasket.authorization';

// Читает сохранённую авторизацию из localStorage и проверяет её целостность.
// Возвращает объект авторизации или null.
export function getStoredAuthorization() {
	try {
		const raw = localStorage.getItem(AUTH_STORAGE_KEY);
		if (!raw) return null;
		const parsed = JSON.parse(raw);
		if (!parsed || typeof parsed.accessToken !== 'string' || !parsed.accessToken) return null;
		return parsed;
	} catch {
		return null;
	}
}

// Возвращает accessToken текущего пользователя или пустую строку.
export function getAccessToken() {
	return getStoredAuthorization()?.accessToken || '';
}

// Авторизован ли пользователь (есть ли валидный токен доступа).
export function isAuthorized() {
	return Boolean(getAccessToken());
}

// Сохраняет авторизацию в localStorage.
export function storeAuthorization(authorization) {
	try {
		localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(authorization));
	} catch {
		// localStorage может быть недоступен — игнорируем, авторизация всё равно активна в памяти.
	}
	return authorization;
}

// Удаляет сохранённую авторизацию.
export function clearAuthorization() {
	try {
		localStorage.removeItem(AUTH_STORAGE_KEY);
	} catch {
		// игнорируем
	}
}

// Универсальный запрос к API с поддержкой accessToken и разворачиванием
// обёртки `{ result: ... }`.
export async function apiRequest(path, { method = 'GET', body, accessToken, baseUrl } = {}) {
	const headers = { platform: 'web' };
	if (body !== undefined) headers['Content-Type'] = 'application/json';
	if (accessToken) headers.accessToken = accessToken;

	const base = (baseUrl || getApiUrl()).replace(/\/+$/, '');
	const response = await fetch(`${base}/${path.replace(/^\/+/, '')}`, {
		method,
		headers,
		body: body === undefined ? undefined : JSON.stringify(body)
	});

	const text = await response.text();
	let payload = null;
	if (text) {
		try {
			payload = JSON.parse(text);
		} catch {
			payload = text;
		}
	}

	if (!response.ok) {
		const error = new Error(
			payload?.message || payload?.title || `Ошибка запроса (${response.status})`
		);
		error.status = response.status;
		throw error;
	}

	return payload?.result ?? payload;
}
